import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../AbstractElements';
import VoucherContain from '../../../Component/Learning/Voucher';

const VoucherPage = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="Kupon List" parent="Kupon" title="Daftar Kupon" />
            <VoucherContain />
        </Fragment>
    );
};
export default VoucherPage;